import PushNotificationIOS from '@react-native-community/push-notification-ios'

export const register = ({ onRegister, onNotification }) => {
  PushNotificationIOS.addEventListener('register', handleRegister(onRegister))
  PushNotificationIOS.addEventListener('localNotification', handleLocalNotification(onNotification)) // prettier-ignore
  PushNotificationIOS.addEventListener('notification', handleRemoteNotification(onNotification)) // prettier-ignore
}

const handleLocalNotification = callback => notification => {
  const data = notification.getData()

  if (data.route && data.route.target) {
    callback(data.route)
  }

  notification.finish(PushNotificationIOS.FetchResult.NoData)
}

const handleRemoteNotification = callback => notification => {
  const data = notification.getData()

  if (
    data.route &&
    data.route.target &&
    data.applicationLaunchedViaNotification &&
    data.applicationLaunchedViaNotification === true
  ) {
    callback(data.route)
  }

  notification.finish(PushNotificationIOS.FetchResult.NoData)
}

const handleRegister = callback => token => {
  console.log('-------------------> [REGISTERING]', JSON.stringify(token))

  callback(token)
}

export const requestPermission = () => {
  console.log('Requesting notifications permission')

  PushNotificationIOS.requestPermissions()
}
